import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import ExoAvatar from '../../../components/exo/ExoAvatar';
import { renderHours } from '../worktime';
import { useTranslation } from 'react-i18next';

// Compact row used by the list view of the time tracking page.
export const ProjectListItem = ({
  project,
  onClick,
  disabled = false,
  disabledReason = '',
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const clientName = project.client
    ? project.clientType === 'company'
      ? project.client.name
      : `${project.client.salutation || ''} ${project.client.firstName || ''} ${
          project.client.lastName || ''
        }`.trim()
    : t('Internal');

  const avatarName = project.client
    ? project.clientType === 'company'
      ? project.client.nameShort
      : `${project.client.lastName || ''} ${project.client.firstName || ''}`
    : '';

  function handleClick() {
    if (disabled) return;
    if (onClick) onClick(project);
  }

  const row = (
    <Box
      onClick={handleClick}
      className="w-full flex flex-row items-center gap-3 rounded-lg backdrop-blur-lg px-3 py-2"
      sx={{
        bgcolor: colors.glass,
        borderColor: colors.glass,
        borderWidth: '1px',
        opacity: disabled ? 0.45 : 1,
        filter: disabled ? 'grayscale(1)' : 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ':hover': !disabled && {
          borderColor: colors.success,
          backgroundColor: colors.success + '30',
        },
      }}
    >
      {project.image?.temporaryUrl ? (
        <img
          src={project.image.temporaryUrl}
          className="h-10 w-10 rounded-[5px] object-cover shrink-0"
          alt=""
        />
      ) : (
        <ExoAvatar
          picture={project.client?.logo?.temporaryUrl}
          type={project.clientType || 'company'}
          name={avatarName}
          size="40px"
        />
      )}
      <Typography
        variant="h5"
        className="monospace opacity-50 shrink-0 hidden sm:block"
      >
        {project.nr}
      </Typography>
      <Box className="flex flex-col items-start grow min-w-0">
        <Typography
          variant="h5"
          sx={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            textAlign: 'left',
          }}
        >
          <b>{project.name}</b>
        </Typography>
        <Typography variant="h6" className="opacity-80">
          {clientName}
        </Typography>
      </Box>
      <Typography
        variant="h5"
        className="monospace opacity-50 shrink-0 hidden md:block"
      >
        {project.externalNr}
      </Typography>
      <Typography variant="h4" className="monospace shrink-0" fontWeight={500}>
        {renderHours(project.timeTotal || 0)} h
      </Typography>
    </Box>
  );

  if (!disabled) return row;

  return (
    <Tooltip title={disabledReason} arrow>
      {row}
    </Tooltip>
  );
};
